export const SET_TOKEN = 'SET_TOKEN'
export const SET_ROLES = 'SET_ROLES'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_PASSTHROUGH = 'SET_PASSTHROUGH'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_CONTACT_ID = 'SET_CONTACT_ID'
export const SET_PHONE = 'SET_PHONE'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const SET_LOCATION_KEY = 'SET_LOCATION_KEY'
export const SET_BUSINESS_USERS = 'SET_BUSINESS_USERS'
export const IS_NEW = 'IS_NEW'
export const DEMO_MODE = 'DemoMode'
export const SET_DEMO_MODE = 'SET_DEMO_MODE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_LOGGING = 'SET_LOGGING'
export const SHOW_LOGGING = 'SHOW_LOGGING'
export const SET_LOG_ENTRY = 'SET_LOG_ENTRY'
export const CLEAR_LOG = 'CLEAR_LOG'
export const SET_NOTIFICATION_TOKEN = 'SET_NOTIFICATION_TOKEN'
export const SET_SOLUTION = 'SET_SOLUTION'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_ISMAHLE = 'SET_USER_ISMAHLE'
export const SET_USER_ISTECHPRO = 'SET_USER_ISTECHPRO'
export const SET_USERINFO = 'SET_USERINFO'

export const SESSION_ROLES_NAME = 'auth/roles'
export const SESSION_TOKEN_NAME = 'auth/token'
export const SESSION_USER_PROFILE = 'auth/profile'
export const SESSION_USER_TOKEN = 'auth/usertoken'
export const SESSION_PRIMARY_ROLE = 'auth/primaryRole'
export const SESSION_LANGUAGE = 'auth/language'
export const SESSION_NOTIFICATION_TOKEN = 'auth/notificationToken'
export const SESSION_SOLUTION = 'auth/solution'
export const SESSION_CONTACT_ID = 'auth/contactId'

export const SET_MAHLE_COIN_COUNT = 'SET_MAHLE_COIN_COUNT'
export const SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS = 'SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS'
export const SET_MAHLE_API_ERROR_MSG = 'SET_MAHLE_API_ERROR_MSG'
export const RESET_MAHLE_COIN_BALANCE = 'RESET_MAHLE_COIN_BALANCE'
export const RESET_MAHLE_DIAGNOSTIC_LICENSE_STATUS = 'RESET_MAHLE_DIAGNOSTIC_LICENSE_STATUS'
export const RESET_MAHLE_API_ERROR_MSG = 'RESET_MAHLE_API_ERROR_MSG'
export const RESET_USER_ISMAHLE = 'RESET_USER_ISMAHLE'
export const RESET_USER_ISTECHPRO = 'RESET_USER_ISTECHPRO'
export const SESSION_MAHLE_COIN_BALANCE = 'auth/mahleCoinBalance'
export const SESSION_MAHLE_DIAGNOSTIC_LICENSE_STATUS = 'auth/diagnosticLicenseStatus'
export const SESSION_MAHLE_API_ERROR_MSG = 'auth/mahleApiErrorMsg'
export const SESSION_USER_ISMAHLE = 'auth/userIsMahle'
export const SESSION_USER_ISTECHPRO = 'auth/userIsTechPro'
export const SET_TERMANDCONDITIONS_UI_MESSAGE = 'SET_TERMANDCONDITIONS_UI_MESSAGE'

export const SET_USER_RAG_ONLY = 'SET_USER_RAG_ONLY'
export const SESSION_RAG_ONLY = 'auth/ragOnly'
export const SET_USER_SHOW_RAG = 'SET_USER_SHOW_RAG'
export const SESSION_SHOW_RAG = 'auth/showRag'

export const SET_FULL_USER_DATA = 'SET_FULL_USER_DATA'
export const SESSION_FULL_USER_DATA = 'auth/fullUserData'



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js